/** Texto compacto para listados, PDF, WhatsApp y encuesta pública. */
export function formatActuacionHorario(act) {
  const hi = act?.horaInicio != null && String(act.horaInicio).trim() ? String(act.horaInicio).trim() : '';
  const hf = act?.horaFin != null && String(act.horaFin).trim() ? String(act.horaFin).trim() : '';
  if (hi && hf) return `${hi} – ${hf}`;
  if (hi) return hi;
  if (hf) return hf;
  return '';
}

function catalogRow(tipo, catalog) {
  const code = String(tipo ?? '')
    .trim()
    .toUpperCase();
  if (!code) return null;
  if (Array.isArray(catalog)) {
    return catalog.find((r) => String(r?.codigo ?? '').trim().toUpperCase() === code) || null;
  }
  if (catalog && typeof catalog.get === 'function') {
    return catalog.get(code) || null;
  }
  return null;
}

/**
 * Etiqueta legible del tipo de actuación.
 * @param {string} tipo — código `TipoFormacion`
 * @param {Array<{ codigo: string, nombre?: string }>|Map<string, object>} [catalog] — filas del catálogo API (o `byCodigo` del hook)
 */
export function labelTipoActuacion(tipo, catalog) {
  const row = catalogRow(tipo, catalog);
  if (row?.nombre) return row.nombre;
  const raw = String(tipo ?? '').trim();
  return raw || 'Otro';
}

/**
 * Color Chakra para badges (`colorScheme`).
 * @param {string} tipo
 * @param {Array<{ codigo: string, colorChakra?: string }>|Map<string, object>} [catalog]
 */
export function colorTipoActuacion(tipo, catalog) {
  const row = catalogRow(tipo, catalog);
  const c = row?.colorChakra != null && String(row.colorChakra).trim() ? String(row.colorChakra).trim() : '';
  return c || 'gray';
}
